export default {
  searchOption: null
}
